import { Device } from "./device";
import { JsonProperty } from "../requests/jsonparser";

export enum Permission {
    ANALYTICS = 'analytics',
    USER = 'user',
    USER_ADMIN = 'user_admin',
    ALBUM = 'album',
    RADIOCHART = 'radiochart',
    META = 'meta',
    CURATED = 'curated',
    REPORTING = 'reporting',
    PODCAST = 'podcast',
    PLAYLIST = 'playlist',
    ARTIST = 'artist',
    ADMINISTRATOR = 'administrator',
    COUPON = 'coupon',
    COUPON_REPORTING = 'coupon_reporting',
    GENRE = 'genre',
    CATEGORY = 'category',
    TAG = 'tag',
    BANNER = 'banner',
    ADS = 'ads',
    LIVE = 'live',
    GIVEAWAY = 'giveaway',
    FEATURED = 'featured'
}

export enum SpecialPermission {
    QC = 'qc',
    Financial = 'financial'
}

export class User {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'User' })
    MODELNAME: string;

    @JsonProperty({ required: true, type: 'number' })
    id: number;


    @JsonProperty({ type: 'string?' })
    email?: string;

    @JsonProperty({ type: 'string' })
    full_name: string;

    @JsonProperty({ type: 'string' })
    theme: 'black' | 'white'

    @JsonProperty({ type: 'string?' })
    username: string;

    @JsonProperty({ clazz: Device, type: 'Device?' })
    devices?: Device[];

    @JsonProperty({ type: 'string?' })
    profile_image_url?: string;

    @JsonProperty({ type: 'string?' })
    refresh_token: string | undefined;

    @JsonProperty({ type: 'string?' })
    profile_image_thumbnail_url?: string;

    @JsonProperty({ type: 'string?' })
    profile_image_medium_url?: string;

    @JsonProperty({ type: 'boolean?' })
    hq_allowed?: boolean;

    @JsonProperty({ type: 'boolean?' })
    verification_complete?: boolean;

    @JsonProperty({ type: 'boolean?' })
    is_admin?: boolean;

    @JsonProperty({ type: 'string?' })
    tshirt_size?: string;

    @JsonProperty({ type: 'string?' })
    affiliation?: string;

    @JsonProperty({ type: 'any?' })
    admin_features?: { features: string[] }

    @JsonProperty({ type: 'string?' })
    dob?: string;

    @JsonProperty({ type: 'string?' })
    dj_type?: string;

    @JsonProperty({ type: 'string' })
    verification_status: 'verified' | 'pending' | 'declined' | 'not-submitted'

    @JsonProperty({ type: 'boolean?' })
    beta_tester?: boolean;
}


// WEBPACK FOOTER //
// ./src/api/src/models/user.ts